<template>
  <base-tutorial :steps="steps">
    <div>
      <h2>Olá! Vamos realizar a validação das responsabilidades?</h2>
    </div>

    <div>
      <h2>Competências</h2>
      <div>
        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          Na aba COMPETÊNCIAS você pode selecionar a(s) subunidade(s)
          hierarquicamente vinculada(s) a sua e visualizar o rol de competências
          técnicas (gerais ou inseridas) necessárias para realizar uma
          responsabilidade.
        </p>
      </div>
    </div>

    <div>
      <h2>Responsabilidades</h2>
      <div>
        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          Na aba RESPONSABILIDADES você pode selecionar a(s) subunidade(s)
          hierarquicamente vinculada(s) a sua e visualizar as informações sobre:
          responsabilidade, impacto, dificuldade e competências técnicas.
        </p>
        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          Recomenda-se visualizar uma subunidade por vez.
        </p>
      </div>
    </div>

    <div>
      <h2>Validação de responsabilidades</h2>
      <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
        Antes de validar cada responsabilidade de uma subunidade, pergunte-se:
      </p>
      <p class="mx-2 pa-2 text-center info--text font-weight-medium text-lg-h6">
        Essa responsabilidade contribui para a realização da missão da unidade?
      </p>
      <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
        Se a resposta for “sim”, tem-se uma responsabilidade, se for “não”, é
        apenas uma tarefa e não precisa ser validada, ou merece ser reformulada.
      </p>
    </div>

    <div>
      <h2>Níveis de impacto, dificuldade e competências técnicas</h2>
      <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
        Durante a etapa de validação das responsabilidades você pode alterar o
        nível de impacto e de dificuldade para a realização de cada uma, além de
        incluir ou excluir competências técnicas necessárias para sua execução.
      </p>
    </div>

    <div>
      <h2>Importante!</h2>
      <div class="mx-6 pa-4 justify-center">
        <ul>
          <li>
            <p class="text-start font-weight-medium info--text text-lg-h6">
              Verifique se a responsabilidade descreve “o que fazer” e não o
              “como fazer”
            </p>
          </li>
          <li>
            <p class="text-start font-weight-medium info--text text-lg-h6">
              Observe se o verbo encontra-se no
              <span class="error--text">infinitivo</span> + contextualização
            </p>
            <p class="text-start font-weight-medium text-lg-h6">
              Exemplo 1: <span class="error--text">Convocar</span>
              <span
                class="info--text"
              >candidatos aprovados em concurso público para cargos
                efetivos.</span>
            </p>
          </li>
          <li>
            <p class="text-start font-weight-medium info--text text-lg-h6">
              Cada servidor lotado na unidade deve executar no mínimo 1 (uma)
              das responsabilidades descritas, por isso, recomenda-se realizar a
              validação do mapeamento técnico em conjunto com a chefia da
              unidade.
            </p>
          </li>
        </ul>
      </div>
    </div>
  </base-tutorial>
</template>

<script>
import BaseTutorial from '../BaseTutorial';

export default {
  name: 'TutorialValidacaoResponsabilidade',

  components: { BaseTutorial },

  data() {
    return {
      steps: [
        'Introdução',
        'Competências',
        'Responsabiliades',
        'Validação de Responsabilidades',
        'Impacto, Dificuldade e Competências Técnicas',
        'Importante',
      ],
    };
  },
};
</script>
